export default __webpack_public_path__ + "images/defaultBanner.0a408f45af539e48b6c059720b2eeea6.jpg";